import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils";
import { VAT_RATE_PERCENT } from "../../utils/vat";

interface TotalsSummaryProps {
  lineCount?: number;
  subtotal: number;
  discountPercent: number | null | undefined;
  discountAmount: number;
  totalNoTax: number;
  taxAmount: number;
  grandTotal: number;
}

const Line = ({
  label,
  value,
  strong = false,
}: {
  label: ReactNode;
  value: ReactNode;
  strong?: boolean;
}) => (
  <Box display="flex" justifyContent="space-between" alignItems="baseline" py={0.5}>
    <Typography variant={strong ? "subtitle1" : "body2"} fontWeight={strong ? 700 : 400}>
      {label}
    </Typography>
    <Typography
      variant={strong ? "h6" : "body2"}
      fontWeight={strong ? 700 : 500}
      color={strong ? "primary" : "text.primary"}
    >
      {value}
    </Typography>
  </Box>
);

/** รวมเงิน → ส่วนลด → ยอดก่อน VAT → VAT 7% → ยอดสุทธิ, the order the printed bill uses. */
export default function TotalsSummary({
  lineCount,
  subtotal,
  discountPercent,
  discountAmount,
  totalNoTax,
  taxAmount,
  grandTotal,
}: TotalsSummaryProps) {
  const hasDiscount = discountPercent != null && discountPercent > 0;

  return (
    <Box>
      {lineCount !== undefined && <Line label="จำนวนรายการ" value={`${lineCount} รายการ`} />}
      <Line label="รวมเงิน" value={formatNumber(subtotal)} />
      <Line
        label={hasDiscount ? `ส่วนลด ${discountPercent}%` : "ส่วนลด"}
        value={discountAmount > 0 ? `-${formatNumber(discountAmount)}` : formatNumber(0)}
      />
      <Line label="ยอดก่อน VAT" value={formatNumber(totalNoTax)} />
      <Line label={`VAT ${VAT_RATE_PERCENT}%`} value={formatNumber(taxAmount)} />
      <Divider sx={{ my: 1 }} />
      <Line label="ยอดสุทธิ" value={formatNumber(grandTotal)} strong />
    </Box>
  );
}
